import { apiClient } from "shared/utils";
import { RegisterResponse, RegisterRequest } from "api/models";

export const postRegister = async (values: RegisterRequest) => {
  const { data } = await apiClient.post<RegisterResponse>("/register", values);

  return data;
};
